import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.0306 12.5306L9.53063 20.0306C9.46094 20.1003 9.37822 20.1556 9.28717 20.1933C9.19613 20.231 9.09855 20.2504 9 20.2504C8.90146 20.2504 8.80387 20.231 8.71283 20.1933C8.62178 20.1556 8.53906 20.1003 8.46938 20.0306C8.39969 19.9609 8.34442 19.8782 8.30671 19.7872C8.26899 19.6961 8.24958 19.5985 8.24958 19.5C8.24958 19.4014 8.26899 19.3039 8.30671 19.2128C8.34442 19.1218 8.39969 19.039 8.46938 18.9694L15.4397 12L8.46938 5.03061C8.32865 4.88988 8.24958 4.69901 8.24958 4.49999C8.24958 4.30097 8.32865 4.1101 8.46938 3.96936C8.61011 3.82863 8.80098 3.74957 9 3.74957C9.19902 3.74957 9.3899 3.82863 9.53063 3.96936L17.0306 11.4694C17.1004 11.539 17.1557 11.6217 17.1934 11.7128C17.2312 11.8038 17.2506 11.9014 17.2506 12C17.2506 12.0986 17.2312 12.1961 17.1934 12.2872C17.1557 12.3782 17.1004 12.461 17.0306 12.5306Z",
		fill: "current"
	})
});
export default SvgArrowRight;
